export default "__VITE_ASSET__DTaQQBzf__"